import { Outlet
 } from "react-router-dom";
export default function DataFormOutlet(){
  return(
    <div>
      <Outlet / > 
    </div>
  );
}